module.exports = __webpack_public_path__ + "static/media/sms-white.85874bc2.svg";